/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Loading from '../../../pages/Loading';
import {
  MediaCommunitySkin,
  MediaOutlet,
  MediaPlayer,
} from '@vidstack/react';
import 'vidstack/styles/defaults.css';
import 'vidstack/styles/community-skin/video.css';
import IconButton from '../../common/IconButton';
import {
  setReviewModal,
  setSidebarOpen,
} from '../../../redux/slices/viewCourseSlice';
import {
  PlayIcon,
  PauseIcon,
  ReplayIcon,
  NextIcon,
  PreviousIcon,
  SeekForward10Icon,
} from '@vidstack/react/icons';
import { updateCourseProgress } from '../../../services/operations/courseApi';
import { ACCOUNT_TYPE } from '../../../utils/constants';
import Hamburger from 'hamburger-react';
import './VideoView.css';

const VideoView = () => {
  const {
    courseSectionData,
    courseEntireData,
    isSidebarOpen,
  } = useSelector((state) => state.viewCourse);
  const { user } = useSelector((state) => state.profile);
  const { courseId, sectionId, subSectionId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const ref = useRef();
  const [lecture, setlecture] = useState([]);
  const [videoEnded, setVideoEnded] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [loading, setLoading] = useState(true);
  const [fullScreen, setFullScreen] = useState(false);

  const handleFullscreenChange = () => {
    setFullScreen(!!(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement));
  };

  window.addEventListener('resize', () => {
    setScreenWidth(window.innerWidth);
  });
  const currentSectionIndex = courseSectionData.findIndex(
    (section) => section._id === sectionId
  );
  const currentSubSectionIndex =
    currentSectionIndex >= 0
      ? courseSectionData[currentSectionIndex].subSection.findIndex(
        (subSection) => subSection._id === subSectionId
      )
      : 0;
  const subSectionLength = currentSectionIndex >= 0
    ? courseSectionData[currentSectionIndex].subSection.length
    : 0;
  const isFirstVideo =
    currentSectionIndex === 0 && currentSubSectionIndex === 0;
  const isLastVideo =
    currentSectionIndex === courseSectionData.length - 1 &&
    currentSubSectionIndex === subSectionLength - 1;

  const nextVideo = () => {
    if (!isLastVideo) {
      if (currentSubSectionIndex === subSectionLength - 1) {
        const nextSectionId =
          courseSectionData[currentSectionIndex + 1]._id;
        const nextSubSectionId =
          courseSectionData[currentSectionIndex + 1].subSection[0]._id;
        navigate(
          `/course/${courseEntireData?.courseName.toLowerCase()}/${courseEntireData?._id}/${nextSectionId}/${nextSubSectionId}`
        );
      } else {
        const nextSubSectionId =
          courseSectionData[currentSectionIndex].subSection[
            currentSubSectionIndex + 1
          ]._id;

        navigate(
          `/course/${courseEntireData?.courseName.toLowerCase()}/${courseEntireData?._id}/${sectionId}/${nextSubSectionId}`
        );
      }
    }
  };
  const prevVideo = () => {
    if (!isFirstVideo) {
      if (currentSubSectionIndex === 0) {
        const prevSectionId =
          courseSectionData[currentSectionIndex - 1]._id;
        const prevSubSectionId =
          courseSectionData[currentSectionIndex - 1].subSection[
            courseSectionData[currentSectionIndex - 1].subSection.length - 1
          ]._id;
        navigate(
          `/course/${courseEntireData?.courseName.toLowerCase()}/${courseEntireData?._id}/${prevSectionId}/${prevSubSectionId}`
        );
      } else {
        const prevSubSectionId =
          courseSectionData[currentSectionIndex].subSection[
            currentSubSectionIndex - 1
          ]._id;
        navigate(
          `/course/${courseEntireData?.courseName.toLowerCase()}/${courseEntireData?._id}/${sectionId}/${prevSubSectionId}`
        );
      }
    }
  };
  const lectureCompletionHandler = () => {
    dispatch(updateCourseProgress(courseId, subSectionId, user));
  };
  useEffect(() => {
    setLoading(true);
    ; (async () => {
      if (!courseSectionData) return;
      if (!courseId && !sectionId && !subSectionId) {
        navigate('/dashboard/enrolled-courses');
      } else {
        for (const section of courseSectionData) {
          if (section._id === sectionId) {
            for (const subSection of section.subSection) {
              if (subSection._id === subSectionId) {
                setlecture(subSection);
                setVideoEnded(false);
              }
            }
          }
        }
      }
    })();
    setLoading(false);
  }, [location]);

  if (loading) {
    return <Loading />;
  }
  return (
    <div className='text-richblack-5 h-full relative'>
      {!lecture ? (
        <div className='text-3xl'>No Video Found</div>
      ) : (
        <div>
          <MediaPlayer
            title={lecture?.title}
            src={lecture?.videoUrl}
            poster={courseEntireData?.thumbnail}
            onFullscreenChange={handleFullscreenChange}
            thumbnails={courseEntireData?.thumbnail}
            onEnded={() =>
              user.accountType === ACCOUNT_TYPE.STUDENT && setVideoEnded(true)
            }
            onPlay={() => setVideoEnded(false)}
            className='outline-none'
          >
            <MediaOutlet />
            {screenWidth < 1024 && (
              <div
                ref={ref}
                onClick={() =>
                  isSidebarOpen
                    ? dispatch(setSidebarOpen(false))
                    : dispatch(setSidebarOpen(true))
                }
                className='text-white z-[100] absolute md:scale-y-[0.85] top-0 left-0 scale-[0.75] flex justify-end'
              >
                {!fullScreen &&
                  <Hamburger
                    toggled={isSidebarOpen}
                    className='focus:bg-none z-50'
                  />
                }
              </div>
            )}
            <div className='media-ui flex gap-16 justify-center items-center'>
              <button
                type='button'
                disabled={isFirstVideo}
                onClick={prevVideo}
                className='flex justify-center previous-button items-center'
              >
                <PreviousIcon size={48} className='previous-button-icon' />
              </button>

              <media-seek-button
                seconds='-10'
                class='seek-button-negative data-[hover]:bg-transparent'
              >
                <SeekForward10Icon />
              </media-seek-button>

              <media-play-button
                class='w-16 play-button h-16 data-[hover]:bg-transparent'
              >
                <svg slot='play'>
                  <PlayIcon size={48} />
                </svg>
                <svg slot='pause'>
                  <PauseIcon size={48} />
                </svg>
                <svg slot='replay'>
                  <ReplayIcon size={48} />
                </svg>
              </media-play-button>

              <media-seek-button
                seconds='+10'
                class='seek-button-positive data-[hover]:bg-transparent'
              >
                <SeekForward10Icon />
              </media-seek-button>

              <button
                type='button'
                onClick={() => {
                  videoEnded && lectureCompletionHandler();
                  nextVideo();
                }}
                className='next-button flex justify-center items-center'
              >
                <NextIcon size={48} className='next-button-icon' />
              </button>
            </div>
            <MediaCommunitySkin />
          </MediaPlayer>
        </div>
      )}
      <div className='flex sm:flex-row flex-col sm:items-center gap-5'>
        <div className='p-3 flexflex-col text-start gap-2 sm:w-[75%]'>
          <header className='text-2xl pb-2 font-semibold'>
            {lecture?.title}
          </header>
          <p className='text-richblack-200'>{lecture?.description}</p>
        </div>
        {user?.accountType === ACCOUNT_TYPE.STUDENT && (
          <div>
            <IconButton
              text='Review'
              onClick={() => dispatch(setReviewModal(true))}
              customClasses={
                'bg-yellow-50 cursor-pointer rounded-md py-2 px-5 mx-4 font-semibold transition-all duration-200 text-richblack-900 hover:scale-95'
              }
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoView;